export default "__VITE_ASSET__bd9a7064__"